import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import logo from "../../assets/images/footer/logo.svg";
import twitter from "../../assets/images/footer/twitter.svg";
import discord from "../../assets/images/footer/discord.svg";
// import notification from "../../assets/images/header/notification.svg";
import menuicon from "../../assets/images/header/menuicon.svg";
import searchicon from "../../assets/images/header/search.svg";
import user from "../../assets/images/header/avatar.png";
import chat from "../../assets/images/footer/chat.svg";
import activeMenu from "../../assets/images/header/active-menu.svg";
import searchActive from "../../assets/images/header/search-active.svg";
import menu1 from "../../assets/images/header/menu1.svg";
import menu2 from "../../assets/images/header/menu2.svg";
import menu3 from "../../assets/images/header/menu3.svg";
import menu4 from "../../assets/images/header/menu4.svg";
import menu5 from "../../assets/images/header/menu5.svg";
import chatActive from '../../assets/images/footer/active-chat.svg'
import "./footer.css";

const Footer = ({ handleSidebar, handleChat, openSidebar, search, show }) => {
  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="footer-logo">
              <img src={logo} alt="" />
              <p>Copyright © 500 Casino. All rights reserved</p>
              <ul>
                <li>
                  <Link to="">
                    <img src={twitter} alt="twitter" />
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <img src={discord} alt="discord" />
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-menu">
              <h5>Games</h5>
              <ul>
                <li>
                  <Link to="/roulette">Roulette</Link>
                </li>
                <li>
                  <Link to="/dice">Dice</Link>
                </li>
                <li>
                  <Link to="/mines">Mines</Link>
                </li>
                <li>
                  <Link to="/tower">Tower</Link>
                </li>
                <li>
                  <Link to="/slots">Slots</Link>
                </li>
                <li>
                  <Link to="/livegames">Live Games</Link>
                </li>
              </ul>
            </div>

            <div className="footer-menu">
              <h5>About</h5>
              <ul>
                <li>
                  <Link to="/faq">Frequently Asked</Link>
                </li>
                <li>
                  <Link to="/overview">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/tip">AML / KYC Policy</Link>
                </li>
                <li>
                  <Link to="/fairness">Fairness</Link>
                </li>
                <li>
                  <Link to="/">Terms of Service</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="copyright-text text-center">
            <p>
              Bull Gaming N.V. payments can be processed by WINGAMING SUPPORT
              LIMITED (Registration Number HE406701). Company Address: Avlonos,
              1, MARIA HOUSE, 1075, Nicosia, Cyprus
            </p>
          </div>
        </div>
      </div>
      <div className="sticky-footer">
        <div
          className={`sticky-link menu-box ${openSidebar ? "active-menu" : ""}`}
          onClick={handleSidebar}
        >
          {openSidebar ? (
            <img src={activeMenu} alt="" />
          ) : (
            <img src={menuicon} alt="" />
          )}
        </div>
        <div
          className={`sticky-link search-box ${search ? "active-menu" : ""}`}
        >
          <Link to="/search">
            {search ? (
              <img src={searchActive} alt="" />
            ) : (
              <img src={searchicon} alt="" />
            )}
          </Link>
        </div>
        <div className={`sticky-link ${show ? "active-menu" : ""}`} onClick={handleChat}>
          {show ? <img src={chatActive} alt="" /> : <img src={chat} alt="" />}
        </div>
        <div className="my-profile-menu">
          <div className="p-name">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-profile">
                <div className="sticky-link p-pic">
                  <img src={user} alt="" />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Link to="/settings">
                  <img src={menu1} alt="" /> User Profile
                </Link>
                <Link to="/blog">
                  <img src={menu2} alt="" /> Blog
                </Link>
                <Link to="/affiliates">
                  <img src={menu3} alt="" /> Affiliates
                </Link>
                <Link to="/rewards">
                  <img src={menu4} alt="" /> Rewards
                </Link>
                <Dropdown.Item>
                  <img src={menu5} alt="" /> Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* <div className='notification-icon'>
            <Button>
              <img src={notification} alt='' />
            </Button>
          </div> */}
          </div>
        </div>
        {/* <div className="sticky-link">
          <img src={notification} alt="" />
        </div> */}
      </div>
    </>
  );
};

export default Footer;
